import { useMemo } from 'react';
import { Button } from '@mui/material';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Callout, CalloutBody, CalloutFooter, CalloutTitleHighlight } from '../../components/Callout';

const AccessDenyCallout = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const locationPathname = useMemo(() => {
        if (location.pathname === '/accessDenied') {
            if (searchParams.get('path')) {
                return searchParams.get('path');
            }
        }

        return location.pathname;
    }, [location.pathname, searchParams]);

    const title = useMemo(() => {
        switch (locationPathname) {
            case '/campaignManager':
            case '/campaign/create':
            case '/campaign/v2/create':
                return (
                    <>
                        Looking for single-sign-on <CalloutTitleHighlight>programmatic control</CalloutTitleHighlight>?
                    </>
                );

            case '/reporting':
            case '/quicksight':
                return (
                    <>
                        Looking for consolidated <CalloutTitleHighlight>reporting</CalloutTitleHighlight>?
                    </>
                );

            case '/attribution':
                return (
                    <>
                        Looking for proof it's <CalloutTitleHighlight>working</CalloutTitleHighlight>?
                    </>
                );

            case '/hat':
                return (
                    <>
                        Looking for even more <CalloutTitleHighlight>proof</CalloutTitleHighlight>?
                    </>
                );

            case '/crmUpload':
                return (
                    <>
                        Looking to do more with <CalloutTitleHighlight>data</CalloutTitleHighlight>?
                    </>
                );

            case '/insights':
                return (
                    <>
                        Looking for unique <CalloutTitleHighlight>insights</CalloutTitleHighlight>?
                    </>
                );

            case '/creative':
                return (
                    <>
                        Want to put creative into <CalloutTitleHighlight>hyperdrive</CalloutTitleHighlight>?
                    </>
                );
        }

        return 'You are not authorized to access this page.';
    }, [locationPathname]);

    const description = useMemo(() => {
        switch (locationPathname) {
            case '/campaignManager':
            case '/campaign/create':
            case '/campaign/v2/create':
                return 'Get in touch with mission control to unlock the only programmatic platform you’ll need to buy, manage, and measure streaming TV.';

            case '/reporting':
            case '/quicksight':
                return 'Get in touch with mission control to unlock unified reporting in a single dashboard.';

            case '/attribution':
                return 'Get in touch with mission control to unlock attribution reporting for sales, service, and more.';

            case '/hat':
                return 'Get in touch with mission control for access to the pixel that tracks from first impression to last click - including streaming TV views.';

            case '/crmUpload':
                return 'Get in touch with mission control for data onboarding, enrichment, and activation with off-market data and curated deals.';

            case '/insights':
                return 'Get in touch with mission control to unlock insights that power better campaigns.';

            case '/creative':
                return 'Get in touch with mission control for creative ad service that turns data into personalized video ad campaigns.';
        }

        return 'Contact your account rep to enroll and get access today!';
    }, [locationPathname]);

    return (
        <Callout title={title} description={description}>
            <CalloutBody>
                <img
                    alt="Mascot_Astronaut_Waving"
                    src="/Mascot_Astronaut_Waving.png"
                    style={{ width: 'max-content' }}
                />
            </CalloutBody>
            <CalloutFooter>
                <Button
                    size="large"
                    type="submit"
                    variant="contained"
                    component="a"
                    href="mailto:sales@cognitionads.com"
                >
                    Contact Sales
                </Button>
            </CalloutFooter>
        </Callout>
    );
};

export default AccessDenyCallout;
